import { baseUrls } from '@monorepo/common';

export default {
  homeUrl: baseUrls.jobApi,
  // user
  userProfile: '/user/ContactInfo',
  userPublicProfile: '/user/PublicProfile',
  userHeadShot: '/user/PublicProfileHeadshot',
  userOrders: '/user/orders',
  userChangePassword: '/user/ChangePassword',
  userDetails: '/user/GetUserDetails',

  // user email
  checkEmail: '/user/IsEmailChanged',
  confirmEmail: '/user/IsCodeValid',
  getNotAllowedEmailParts: '/misc/GetNotAllowedEmailParts',
  // newsletter
  newsletterGroups: '/user/NewsletterGroups',
  newsletterGroupsUpdate: '/user/NewsletterGroupsUpdate',

  menuSettings: '/AccountApp/MenuSettings',

  // countries
  countries: '/misc/GetCountries',
  usaStates: '/misc/GetStates',

  // help
  help: '/help',

  // brands
  brands: {
    editBrand: (id: string) => `/Brands/${id}`,
    createSubBrand: (id: string) => `/Brands/${id}/subbrand`,
    getBrandDetails: (id: string) => `/Brands/${id}`,
    brandProducts: (id: string) => `/Brands/${id}/products`,
    getLogoUrl: (id: string) => `/Brands/${id}/logo`,
    uploadLogo: (id: string) => `/Brands/${id}/logo`,
    removeLogo: (id: string) => `/Brands/${id}/logo`,
    getProductTypes: '/Brands/Products/types',
    createProduct: (id: string) => `/Brands/${id}/products`,
    getProductDetails: (brandGuid: string, productGuid: string) => `/Brands/${brandGuid}/products/${productGuid}`,
    getProductSubBrands: (id: string) => `/Brands/${id}/subbrands`,
    updateProductDetails: (brandGuid: string, productGuid: string) => `/Brands/${brandGuid}/products/${productGuid}`,
    changeStatusProduct: (brandGuid: string, productGuid: string) => `/Brands/${brandGuid}/products/${productGuid}/changestatus`,
    updateProductPhoto: (brandGuid: string, productGuid: string) => `/Brands/${brandGuid}/products/${productGuid}/photo`,
    //
    getAccessStatus: (id: string) => `/Brands/${id}/access`,
  },
  noshBrands: {
    productTypes: '/NoshBrands/products/types',
    access: (brandGuid: string) => `/NoshBrands/${brandGuid}/access`,
    brand: (brandGuid: string) => `/NoshBrands/${brandGuid}`,
    logo: (brandGuid: string) => `/NoshBrands/${brandGuid}/logo`,
    products: (brandGuid: string) => `/NoshBrands/${brandGuid}/products`,
    productsOrder: (brandGuid: string) => `/NoshBrands/${brandGuid}/products/order`,
    product: (brandGuid: string, productGuid: string) => `/NoshBrands/${brandGuid}/products/${productGuid}`,
    productImages: (brandGuid: string, productGuid: string) => `/NoshBrands/${brandGuid}/products/${productGuid}/images`,
    subBrands: (brandGuid: string) => `/NoshBrands/${brandGuid}/subbrands`,
    retailers: (brandGuid: string) => `/NoshBrands/${brandGuid}/retailers`,
    retailersOrder: (brandGuid: string) => `/NoshBrands/${brandGuid}/retailers/order`,
    retailer: (brandGuid: string, retailerGuid: string) => `/NoshBrands/${brandGuid}/retailers/${retailerGuid}`,
  },
  invoices: {
    invoiceDetails: '/Quotes/InvoiceDetails',
    invoiceDetailsFromTempData: (guid: string) => `/Quotes/InvoiceDetailsFromTempData/${guid}`,
    quotesDetails: (id: string) => `/Quotes/Details/${id}`,
    createDetail: '/Quotes/Details',
    updateDetail: (id: string) => `/Quotes/Details/${id}`,
    deleteDetail: (id: string) => `/Quotes/Details/${id}`,
    paymentTypes: '/Quotes/PaymentTypes',
    confirmInvoice: '/Quotes/ConfirmInvoice',
    saveTempData: '/Quotes/SaveTempData',
    paymentIntent: 'Quotes/PaymentIntent',
    updatePaymentIntent: 'Quotes/UpdatePaymentIntent',
    confirmEmail: 'Quotes/EmailVerification',
    verifyCode: 'Quotes/CodeVerification'
  },
  marketplace: {
    userListings: '/User/MarketplaceListings',
  },
  pressReleases: {
    accountPressReleases: () => '/pressreleases/accountpressreleases',
    upgradePaymentIntent: (listingTypeId: number, companyTypeId: number) => `/pressreleases/pressreleasepaymentintent/${listingTypeId}/${companyTypeId}`,
    getPressRelease: (guid: string) => `/PressReleases/PressRelease/${guid}`,
    getUpgradePrice: (listingTypeId: number, companyTypeId: number) => `/pressreleases/getupgradeprice/${listingTypeId}/${companyTypeId}`,
    upgradeFromAccount: '/pressreleases/upgradefromaccount',
  }
};
